
    import {Component, Vue, Watch} from "vue-property-decorator";
    import statisticApi from "@/api/statistic";

    const {CodeToText, regionData} = require("@/js/region/region");
    import {dictApi} from "@/api/organization";
    import {IPage} from "@/js/page";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import baseUrl from "@/constants";
    @Component({
        name: "Audit_Summary",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        mode = 'Audit_App'; // or Audit_Instr  备案申请  或 器具备案
        dataList = []; //数据列表
        CodeToText = CodeToText;
        regionData = regionData;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        levelData = {};
        mechanismLevelList = []; //单位级别
        // purposeCodeList = []; //器具用途
        instrCatalogueTree = []; //强检目录
        downloadReportRight = false; //下载统计报表权限
        downloadZhuanBaoRight = false; //下载专报报表
        propParam = {
            mechanismName: '', //行政单位
            mechanismRegion: '', //行政单位区域
            mechanismLevel: '', //行政单位级别
            initiatorMechanismName: '', //使用单位
            auditStatus: '',//业务状态
            instrName: '',//器具名称
            purposeCode: '', //器具用途
            catalogue: [], //器具目录
            startTime: '',
            endTime: '',
        } as any
        loading = false;
        downloadExcel = false;
        downloadZhuanbao = false;
        private exportExcel: any;
        showForm = false;
        tabCol = [];
        tableKey = 0;
        listTotal = 0;
        listParam: IPage = {
            size: 100,
            current: 1,
        };

        mounted() {
          this.haveRight();
            //单位区域
            // statisticApi.getMechanismRegion().then((r) => {
            //     const regionCode = r.data.data;
            //     if(regionCode == null){
            //         this.regionData = regionData;
            //     }else{
            //         const region = this.getRegionData(regionCode, regionData);
            //         this.regionData = [ region ];
            //     }
            // });
            //单位级别
            dictApi.listDictItem({typeCode: "dwjb"}).then((r) => {
                if (r.data.result === 0) {
                    const levels = r.data.data;
                    this.mechanismLevelList = levels;
                    this.levelData = Object.fromEntries(levels.map((item: any) => [item.dictKey, item]));
                }
            });
            //器具用途
            // dictApi.list({
            //     category: 2,
            // }).then(r=>{
            //     if(r.data.result === 0){
            //         this.purposeCodeList = r.data.data
            //     }
            // })
            //器具目录
            dictApi.listInstrumentCatalogueTree().then((r) => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTreeV2(rData);
                    this.instrCatalogueTree = rData;
                }
            });
            this.loadDataList(null);
        }
        getRegionData(regionCode: number, projectList: any) : any{
            for (let i = 0; i < projectList.length; i++) {
                let treeItem= projectList[i]
                if(treeItem.value === regionCode ){
                    return treeItem
                }else{
                    if(treeItem.children && treeItem.children.length>0){
                        const res = this.getRegionData(regionCode, treeItem.children);
                        if(res){
                            return res;
                        }
                    }
                }
            }
        }
        refresh(){
            this.loadDataList(null);
        }
        reset(){
            for(const f in this.propParam){
                this.propParam[f] = "";
            }
            this.refresh();
        }
        porjectTreeV2(projectList: any){
            projectList.forEach((project: any) => {
                if(project.children.length == 0){
                    project.children = null;
                }else{
                    this.porjectTreeV2(project.children);
                }
            })
        }
        indexMethod(index: any) {
            return this.listTotal - ((this.listParam.current - 1) * this.listParam.size + index);
        }
        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.loadDataList(null);
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.loadDataList(null);
        }

        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(() => {
                let $table = this.$refs.table as HTMLFormElement;
                if ($table) {
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }

        loadDataList(callback: any) {
            this.loading = true;
            const params = {
                ...this.listParam,
                ...this.propParam,
            } as any;

            if(params.catalogue.length > 0){
                params.catalogueOne = params.catalogue[0];
            }
            if(params.catalogue.length > 1){
                params.catalogueTwo = params.catalogue[1];
            }
            params.catalogue = null;

            let api = null;
            if(this.mode === 'Audit_App'){
                api = statisticApi.listAuditOrderSummary(params);
            }else{
                if(this.mode === 'Audit_Receive'){
                    params.auditStatus = 1
                }else if(this.mode === 'Audit_Rejection'){
                    params.auditStatus = 2;
                }
                api = statisticApi.listAuditInstrSummary(params);
            }
            api.then((r) => {
                if (r.data.result === 0) {
                    const {records, total} = r.data.data;
                    this.dataList = records;
                    this.listTotal = total;
                    this.$nextTick(() => {
                        if (callback) {
                            callback();
                        }
                    });
                }
                this.loading = false;
            });
        }

        onExportExcel() {
            this.loading = true;
            const listParam = JSON.parse(JSON.stringify(this.listParam));
            this.listParam.current = -1;
            let title = "";
            if(this.mode === 'Audit_App'){
                title = "本区域各行政部门备案申请汇总";
            }else if(this.mode === 'Audit_Instr'){
                title = "本区域各行政部门器具备案汇总";
            }else if(this.mode === 'Audit_Receive'){
                title = "本区域各行政部门接收器具汇总";
            }else if(this.mode === 'Audit_Rejection'){
                title = "本区域各行政部门拒收器具汇总";
            }
            this.loadDataList(() => {
                this.exportExcel(() => {
                    this.listParam = listParam;
                    this.loadDataList(() => {
                        this.loading = false;
                    });
                }, title + ".xlsx");
            });
        }
      hasBtn(mode: string){
          if(mode === 'downloadReport'){
            return this.downloadReportRight;
          }
          if(mode === 'downloadzhuanbao'){
          return this.downloadZhuanBaoRight;
        }
      }

      haveRight(){
        const right = this.$store.state.userRights;
        this.downloadReportRight = false;
        this.downloadZhuanBaoRight = false;
        right.forEach((e: any) => {
          if (e.name == "下载统计报表") {
            this.downloadReportRight = true;
          }
          if(e.name=="下载专报统计"){
            this.downloadZhuanBaoRight = true;
          }
        })
      }
      downloadBtn(){
        this.downloadExcel = true;
          statisticApi.export().then((r: any) => {
            this.downloadExcel = false;
             if(r.data.result === 0){
               window.location.href = (baseUrl + "/file/download?file=" + r.data.data + "&name=区域统计报表.xlsx");
             }
          });
      }
      //下载专报
      downloadZBBtn(){
        this.downloadZhuanbao = true;
        statisticApi.exportZB().then((r: any) => {
          this.downloadZhuanbao = false;
          if(r.data.result === 0){
            window.location.href = (baseUrl + "/file/download?file=" + r.data.data + "&name=专报报表.xlsx");
          }
        });
      }
    }
